"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShootRating = void 0;
const react_1 = __importDefault(require("react"));
const Star_png_1 = __importDefault(require("./Star.png"));
const ShootRating_module_css_1 = __importDefault(require("./ShootRating.module.css"));
const hooks_1 = require("../../hooks");
const Row_1 = require("../Row");
function createTypeFormLink({ accountId, answerId, contact, answer, shootId, typeFormId }) {
    return `https://lemonone.typeform.com/to/${typeFormId}?typeform-medium=embed-email#shootid=${shootId}&amp;accountid=${accountId}&amp;contact=${contact}&amp;answers-${answerId}=${answer}`;
}
const ShootRating = props => {
    const component = hooks_1.useIntlScope('@lemonone/components/ShootRating:');
    return (react_1.default.createElement("div", { className: ShootRating_module_css_1.default.wrapper },
        react_1.default.createElement(Row_1.Row, null,
            react_1.default.createElement("p", { className: ShootRating_module_css_1.default.title },
                component('title'),
                ":")),
        react_1.default.createElement(Row_1.Row, null,
            react_1.default.createElement("ul", { className: ShootRating_module_css_1.default.list }, new Array(5).fill(0).map((_, index) => (react_1.default.createElement("li", { key: index, className: ShootRating_module_css_1.default.listItem },
                react_1.default.createElement("a", { href: createTypeFormLink({ ...props, answer: (index + 1).toString() }), target: "_blank", rel: "noreferrer" },
                    react_1.default.createElement("img", { src: Star_png_1.default, className: ShootRating_module_css_1.default.starImage, alt: `Star ${index}` })))))))));
};
exports.ShootRating = ShootRating;
//# sourceMappingURL=ShootRating.js.map